class URLStateManager {
  constructor(config = {}) {
    // @ts-ignore
    this.selectedFilters = config.selectedFilters || [];
    // @ts-ignore
    this.ddcsSection = config.ddcsSection || [];
    // @ts-ignore
    this.ddcsCampusEntity = config.ddcsCampusEntity || [];
    // @ts-ignore
    this.ddcsTerm = config.ddcsTerm || [];
    // @ts-ignore
    this.ddcsCampusDepartment = config.ddcsCampusDepartment || [];
    // @ts-ignore
    this.ddcsCourse = config.ddcsCourse || [];
    // @ts-ignore
    this.addLabelCallback = config.addLabelCallback || (() => {});
    // @ts-ignore
    this.refreshProductsCallback = config.refreshProductsCallback || (() => {});

    this.URL_PARAMS = {
      SHOP_BY: 'shopBy',
      TERM_ID: 'termId',
      DIVISION_DISPLAY_NAME: 'divisionDisplayName',
      DEPARTMENT_DISPLAY_NAME: 'departmentDisplayName',
      COURSE_DISPLAY_NAME: 'courseDisplayName',
      SECTION_DISPLAY_NAME: 'sectionDisplayName',
      STUDENT_ID: 'studentId',
    };

    this.urlParamsToRestore = null;

    // Bind methods to preserve context
    this.parseURLParameters = this.parseURLParameters.bind(this);
    this.setURLSearchParams = this.setURLSearchParams.bind(this);
    this.restoreFormStateFromURL = this.restoreFormStateFromURL.bind(this);
    this.buildFiltersFromURLParams = this.buildFiltersFromURLParams.bind(this);
    this.findMatchingEntities = this.findMatchingEntities.bind(this);
    this.createFilterObject = this.createFilterObject.bind(this);
    this.restoreDropdownsAndUI = this.restoreDropdownsAndUI.bind(this);
    this.setCampusDropdown = this.setCampusDropdown.bind(this);
    this.setTermDropdown = this.setTermDropdown.bind(this);
    this.populateTermsForCampus = this.populateTermsForCampus.bind(this);
    this.restoreAllFormFieldsFromURL =
      this.restoreAllFormFieldsFromURL.bind(this);
    this.restoreFieldsCascade = this.restoreFieldsCascade.bind(this);
    this.continueWithDepartment = this.continueWithDepartment.bind(this);
    this.continueWithCourse = this.continueWithCourse.bind(this);
    this.continueWithSection = this.continueWithSection.bind(this);
    this.finishRestore = this.finishRestore.bind(this);
    this.triggerDepartmentCascadeForRestore =
      this.triggerDepartmentCascadeForRestore.bind(this);
    this.attemptURLRestoration = this.attemptURLRestoration.bind(this);
    this.clearExistingFilters = this.clearExistingFilters.bind(this);
  }

  parseURLParameters() {
    const urlParams = new URLSearchParams(window.location.search);
    const params = {
      // @ts-ignore
      shopBy: urlParams.get(this.URL_PARAMS.SHOP_BY),
      // @ts-ignore
      termId: urlParams.get(this.URL_PARAMS.TERM_ID),
      // @ts-ignore
      divisionDisplayName: urlParams.get(this.URL_PARAMS.DIVISION_DISPLAY_NAME),
      // @ts-ignore
      departmentDisplayName: urlParams.get(
        this.URL_PARAMS.DEPARTMENT_DISPLAY_NAME
      ),
      // @ts-ignore
      courseDisplayName: urlParams.get(this.URL_PARAMS.COURSE_DISPLAY_NAME),
      // @ts-ignore
      sectionDisplayName: urlParams.get(this.URL_PARAMS.SECTION_DISPLAY_NAME),
      // @ts-ignore
      studentId: urlParams.get(this.URL_PARAMS.STUDENT_ID),
    };

    const parsed = {
      termsIds: params.termId && params.sectionDisplayName     ? Array(params.sectionDisplayName.split('|').length).fill(params.termId)     : [],
      divisions: params.divisionDisplayName
        ? params.divisionDisplayName.split('|')
        : [],
      departments: params.departmentDisplayName
        ? params.departmentDisplayName.split('|')
        : [],
      courses: params.courseDisplayName
        ? params.courseDisplayName.split('|')
        : [],
      sections: params.sectionDisplayName
        ? params.sectionDisplayName.split('|')
        : [],
      studentId: params.studentId || null,
    };
    //console.log("urlParamsToRestore ==> ", parsed);
    this.urlParamsToRestore = parsed;    
    return parsed;
  }

  setURLSearchParams() {
    const studentIdField = document.getElementById('student-id');
    // @ts-ignore
    const currentStudentId = studentIdField?.value;

    if (this.selectedFilters.length === 0 && !currentStudentId) {
      this.clearURL();
      return;
    }

    const paramStrings = this.buildParameterStrings();
    this.updateURLWithParameters(paramStrings, currentStudentId);
  }

  clearURL() {
    const params = new URLSearchParams(window.location.search);
    const studentId = params.get(this.URL_PARAMS.STUDENT_ID);

    Object.values(this.URL_PARAMS).forEach(param => params.delete(param));

    if (studentId) {
      params.set(this.URL_PARAMS.STUDENT_ID, studentId);
    }

    const newUrl = params.toString()
      ? `${window.location.pathname}?${params}`
      : window.location.pathname;

    window.history.replaceState({}, '', newUrl);
  }

  buildParameterStrings() {
    const results = {
      selectedCampus: '',
      selectedTermId: '',
      selectedDivision: '',
      selectedDepartment: '',
      selectedcourse: '',
      selectedsection: '',
    };
    // @ts-ignore
    this.selectedFilters.forEach((filterObj, index) => {
      const separator = index === this.selectedFilters.length - 1 ? '' : '|';

      Object.keys(results).forEach(key => {
        const value = filterObj[key] || '';

        
        if (key === 'selectedTermId') {
          if (!results[key]) { 
            results[key] = value; 
          }
        } else {
          results[key] += value + separator; 
        }
      });
    });
    return results;
    
  }

  // @ts-ignore
  updateURLWithParameters(paramStrings, studentId = null) {
    const params = new URLSearchParams(window.location.search);

    

    if (this.selectedFilters.length > 0) {
      const selectedCampus =  studentId ? 'studentid' : 'course';
      const selectedDivision = paramStrings.selectedDivision;
      const selectedDepartment = paramStrings.selectedDepartment;
      const selectedcourse = paramStrings.selectedcourse;
      const selectedsection = paramStrings.selectedsection;
      const selectedTermId = paramStrings.selectedTermId;
      params.set(
        this.URL_PARAMS.SHOP_BY,
        encodeURIComponent(selectedCampus)
      );
      params.set(
        this.URL_PARAMS.DIVISION_DISPLAY_NAME,
        encodeURIComponent(selectedDivision)
      );
      params.set(
        this.URL_PARAMS.DEPARTMENT_DISPLAY_NAME,
        encodeURIComponent(selectedDepartment)
      );
      params.set(
        this.URL_PARAMS.COURSE_DISPLAY_NAME,
        encodeURIComponent(selectedcourse)
      );
      params.set(
        this.URL_PARAMS.SECTION_DISPLAY_NAME,
        encodeURIComponent(selectedsection)
      );
      params.set(
        this.URL_PARAMS.TERM_ID, 
        encodeURIComponent(selectedTermId)
      );

      this.setOrDeleteParam(
        params,
        this.URL_PARAMS.STUDENT_ID,
        // @ts-ignore
        studentId?.trim()
      );
    } else {
      [
        this.URL_PARAMS.SHOP_BY,
        this.URL_PARAMS.DIVISION_DISPLAY_NAME,
        this.URL_PARAMS.DEPARTMENT_DISPLAY_NAME,
        this.URL_PARAMS.COURSE_DISPLAY_NAME,
        this.URL_PARAMS.SECTION_DISPLAY_NAME,
        this.URL_PARAMS.TERM_ID,
      ].forEach(param => params.delete(param));
    }


    
    window.history.replaceState(
      {},
      '',
      `${window.location.pathname}?${params}`
    );
    const currentSearch = window.location.search;
    // @ts-ignore
    const searchData = currentSearch.replaceAll("%2520", "%20").replaceAll("%257C","%7C");
    
    window.history.replaceState(
      {},
      '',
      `${window.location.pathname}${searchData}`
    );
  }

  // @ts-ignore
  setOrDeleteParam(params, key, value) {
    if (value) {
      params.set(key, value);
    } else {
      params.delete(key);
    }
  }

  // @ts-ignore
  async restoreFormStateFromURL(termsIds, divisions, departments, courses, sections) {
    this.clearExistingFilters();
    
    const { filters, campusInfo, termClosedInfo } = await this.buildFiltersFromURLParams(
      termsIds,
      divisions,
      departments,
      courses,
      sections
    );

    console.log("termClosedInfo ==> ", { filters, campusInfo, termClosedInfo })
    

    // Check if term is closed
    if (termClosedInfo) {
      this.showTermClosedError(termClosedInfo);
      return;
    }

    if (filters.length === 0) return;

    // Show subtitle and SHOP NOW button since term is open
    this.showTermOpenElements();

    this.selectedFilters.push(...filters);
    filters.forEach(filter => this.addLabelCallback(filter));
    this.restoreDropdownsAndUI(campusInfo);
  }

  clearExistingFilters() {
    this.selectedFilters.length = 0;
    ['course-list', 'filtered-products'].forEach(id => {
      const element = document.getElementById(id);
      if (element) element.innerHTML = '';
    });
  }

  async buildFiltersFromURLParams(
    // @ts-ignore
    termsIds,
    // @ts-ignore
    divisions,
    // @ts-ignore
    departments,
    // @ts-ignore
    courses,
    // @ts-ignore
    sections
  ) {
    const filters = [];
    let campusInfo = null;
    let termClosedInfo = null;

    const maxLength = Math.max(
      termsIds.length,
      divisions.length,
      departments.length,
      courses.length,
      sections.length
    );

    for (let i = 0; i < maxLength; i++) {
      const courseData = {
        termId: termsIds[i] || '',
        division: divisions[i] || '',
        department: departments[i] || '',
        course: courses[i] || '',
        section: sections[i] || '',
      };

      const hasFullCourseLine = courseData.department && courseData.course && courseData.section;
      // Skip filter building when no full course line, but still check term closed if we have termId
      if (!hasFullCourseLine) {
        if (courseData.termId) {
          const entities = await this.findMatchingEntities(courseData);
          if (entities && entities.termClosed === true) {
            const { campusEntity, termEntity } = entities;
            if (!termClosedInfo) {
              termClosedInfo = {
                campus: campusEntity.name,
                term: termEntity.name,
                department: courseData.department || '',
                course: courseData.course || '',
                campusEntity,
                termEntity,
              };
            }
          }
        }
        continue;
      }

      const entities = await this.findMatchingEntities(courseData);
      if (!entities) continue;

      const { campusEntity, termEntity, termClosed } = entities;

      // Check if term is closed
      if (termClosed === true) {
        if (!termClosedInfo) {
          termClosedInfo = {
            campus: campusEntity.name,
            term: termEntity.name,
            department: courseData.department,
            course: courseData.course,
            campusEntity,
            termEntity,
          };
        }
        // Don't add filters for closed terms, but store the info
        continue;
      }

      if (!campusInfo) {
        campusInfo = {
          campus: campusEntity.name,
          term: termEntity.name,
          campusEntity,
          termEntity,
        };
      }

      filters.push(
        this.createFilterObject(courseData, campusEntity, termEntity)
      );
    }

    return { filters, campusInfo, termClosedInfo };
  }
  /**
   * @param {any} metaobjectType
   * @param {any} query
   */
  async fetchMetaobjects(metaobjectType, query) {
    const proxyPath = '/apps/shopifyData/metaobjects';
    const url = `${proxyPath}?type=${metaobjectType}&query=${query}`;

    try {
        const response = await fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
        credentials: 'same-origin'
        });

        if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();
        console.log('Metaobjects API response received:', result);

        if (result.success) {
          const activeMetaobjects = result.data.filter(item => item.status === "ACTIVE");
          return activeMetaobjects;
        } else {
        throw new Error(result.error || 'Failed to fetch metaobjects');
        }

    } catch (error) {
        console.error('Error fetching metaobjects:', error);
        throw error;
    }
  }
  /**
   * @param {any} queryData
   */
  async fetchProducts(queryData) {
    const proxyPath = '/apps/shopifyData/products';
    const url = `${proxyPath}?query=${queryData}`;

    try {
        const response = await fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
        credentials: 'same-origin'
        });

        if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();

        if (result.success) {
          //console.log('Products fetched:', result.data);
          return result.products;
        } else {
        throw new Error(result.error || 'Failed to fetch products');
        }

    } catch (error) {
        console.error('Error fetching products:', error);
        throw error;
    }
  }
  /**
   * Fetch campus metaobject by campus_entity_id when not in config
   * @param {string} campusEntityId
   * @returns {Promise<object|null>} campus metaobject or null
   */
  async fetchCampusByEntityId(campusEntityId) {
    if (!campusEntityId) return null;
    const query = "fields.campus_entity_id:'" + campusEntityId + "'";
    const campuses = await this.fetchMetaobjects('ddcs_campus', query);
    console.log('Campus by entity ID response:', { campusEntityId, campuses });
    return campuses && campuses.length > 0 ? campuses[0] : null;
  }

  /**
   * @param {{ termId: any; division?: any; department: any; course: any; section: any; }} courseData
   */
  async findMatchingEntities(courseData) {
    // First check if term exists (without is_term_open_flag filter to check its status)
    const queryDataAll = "(fields.term:'"+courseData.termId+"' OR fields.term_id:'"+courseData.termId+"') fields.disabled_flag:false"
    const allTerms = await this.fetchMetaobjects('ddcs_term', queryDataAll);
    
    if(allTerms && allTerms.length > 0){
      const termEntity = allTerms[0];
      let campusEntity = this.ddcsCampusEntity.find(
        // @ts-ignore
        c => c.campus_entity_id === termEntity.campus_entity_id
      );
      // Fallback: fetch campus from metaobjects API by campus_entity_id when not in config
      if (!campusEntity && termEntity.campus_entity_id) {
        campusEntity = await this.fetchCampusByEntityId(termEntity.campus_entity_id);
      }
      if (!campusEntity && termEntity.campus_entity_id) {
        campusEntity = {
          name: 'Campus',
          campus_entity_id: termEntity.campus_entity_id
        };
      }

      // Check if term is closed (explicitly false) or forced closed for testing
      const isTermClosed = termEntity.is_term_open_flag === false || termEntity.is_term_open_flag === 'false';
      
      if(isTermClosed) {
        return campusEntity && termEntity ? { campusEntity, termEntity, termClosed: true } : null;
      }

      return campusEntity && termEntity ? { campusEntity, termEntity, termClosed: false } : null;
    }

    return false;
    
  }

  // @ts-ignore
  createFilterObject(courseData, campusEntity, termEntity) {
    return {
      selectedDepartment: decodeURIComponent(courseData.department),
      selectedCampus: decodeURIComponent(campusEntity.name),
      selectedTerm: decodeURIComponent(termEntity.name),
      selectedTermId: decodeURIComponent(termEntity.term_id),
      selectedcourse: decodeURIComponent(courseData.course),
      selectedsection: decodeURIComponent(courseData.section),
      selectedDivision: decodeURIComponent(courseData.division),
    };
  }
  async fetchMetaobjectsData(termId, campusId) {
    const proxyPath = '/apps/shopifyData/getFilteredData';
    const url = `${proxyPath}?campus_entity_id=${campusId}&term_id=${termId}`;

    try {
        const response = await fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
        credentials: 'same-origin'
        });

        if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();

        if (result.success) {
            const activeMetaobjects = result.data;
            return activeMetaobjects;
        } else {
        throw new Error(result.error || 'Failed to fetch metaobjects');
        }

    } catch (error) {
        console.error('Error fetching metaobjects:', error);
        throw error;
    }
  }
  // @ts-ignore
  async restoreDropdownsAndUI(campusInfo) {
    if (!campusInfo) {
      // @ts-ignore
      this.callIfExists(window.showEmptyState);
      return;
    }

    window.courseData.ddcs_campus_division = [];
    window.courseData.ddcs_campus_department = [];
    window.courseData.ddcs_course = [];
    window.courseData.ddcs_section = [];

    const dataFilters = await this.fetchMetaobjectsData(campusInfo.termEntity.term_id, campusInfo.termEntity.campus_entity_id);

    window.courseData.ddcs_campus_division = dataFilters.ddcs_campus_division;
    window.courseData.ddcs_campus_department = dataFilters.ddcs_campus_department;
    window.courseData.ddcs_course = dataFilters.ddcs_course;
    window.courseData.ddcs_section = dataFilters.ddcs_section;

    this.setCampusDropdown(campusInfo.campus, campusInfo.campusEntity);
    await this.setTermDropdown(
      campusInfo.campus,
      campusInfo.term,
      campusInfo.termEntity
    );
    this.restoreAllFormFieldsFromURL();

    // @ts-ignore
    if (window.courseMaterialsSidebar) {
      // @ts-ignore
      window.courseMaterialsSidebar.openSidePanel();
    }

    this.refreshProductsCallback(this.selectedFilters);
    // @ts-ignore
    this.callIfExists(window.hideLoadingState);
  }

  // @ts-ignore
  setCampusDropdown(campusName, campusEntity) {
    const campusSelect = document.getElementById('campus');
    if (!campusSelect) return;

    // @ts-ignore
    campusSelect.value = campusName;

    if (typeof window !== 'undefined') {
      // @ts-ignore
      window.campus_entity_id = campusEntity.campus_entity_id;
      // @ts-ignore
      window.show_division = campusEntity.is_division_used_flag;
    }

    // @ts-ignore
    if (window.courseMaterialsSidebar) {
      // @ts-ignore
      window.courseMaterialsSidebar.campus_entity_id =
        campusEntity.campus_entity_id;
      // @ts-ignore
      window.courseMaterialsSidebar.show_division =
        campusEntity.is_division_used_flag;
    }
  }

  // @ts-ignore
  async setTermDropdown(campusName, termName, termEntity) {
    const termSelect = document.getElementById('term');
    if (!termSelect) return;

    await this.populateTermsForCampus(campusName);
    // @ts-ignore
    //termSelect.value = termName;
    for (let i = 0; i < termSelect.options.length; i++) {
      termSelect.options[i].selected = false;
    }
    const options = termSelect.options;
    for (let i = 0; i < options.length; i++) {
      if (options[i].text === termName) {
          options[i].selected = true; 
          break; 
      }
    }

    if (typeof window !== 'undefined') {
      // @ts-ignore
      window.term_id = termEntity.term_id;
    }

    // @ts-ignore
    if (window.courseMaterialsSidebar) {
      // @ts-ignore
      window.courseMaterialsSidebar.term_id = termEntity.term_id;
      // @ts-ignore
      window.courseMaterialsSidebar.checkCampusTermSelection();
    }

    this.triggerDepartmentCascadeForRestore();
  }

  // @ts-ignore
  async populateTermsForCampus(campusName) {
    const termSelect = document.getElementById('term');
    if (!termSelect) return;

    termSelect.innerHTML = '<option value="">Term</option>';
    
    // @ts-ignore
    const campus = this.ddcsCampusEntity.find(c => c.name === campusName);
    if (!campus) return;
    //const queryData = "fields.campus_entity_id:'"+campus.campus_entity_id+"' fields.disabled_flag:false fields.is_term_open_flag:true"
    const filteredTerms = window.courseData.ddcs_term.filter(
      term => term.campus_entity_id === campus.campus_entity_id
    );
    const sortValuesByName = (a, b) => {
      const nameA = a.name;
      const nameB = b.name;

      const isNumA = !isNaN(nameA.charAt(0));
      const isNumB = !isNaN(nameB.charAt(0));
      
      if (isNumA && isNumB) {
        return parseInt(nameA) - parseInt(nameB); 
      }
      
      if (isNumA) {
        return -1; 
      }
      
      if (isNumB) {
        return 1; 
      }
      
      return nameA.localeCompare(nameB, undefined, { sensitivity: 'base' });
    };
    const sortedValues = filteredTerms.sort(sortValuesByName);
    

    if (filteredTerms.length > 0) {
      // @ts-ignore
      termSelect.disabled = false;
      // @ts-ignore
      filteredTerms.forEach(term => {
        const option = document.createElement('option');
        option.value = term.term_id;
        option.textContent = term.name;
        termSelect.appendChild(option);
      });
    }
  }

  restoreAllFormFieldsFromURL() {
    
    // @ts-ignore
    if (!this.urlParamsToRestore || !window.courseMaterialsSidebar) return;
    
    const { divisions, departments, courses, sections } =
      this.urlParamsToRestore;
    const values = {
      division: decodeURIComponent(divisions[0]) || '',
      department: decodeURIComponent(departments[0]) || '',
      course: decodeURIComponent(courses[0]) || '',
      section: decodeURIComponent(sections[0]) || '',
    };
    //console.log("values_0 ==> ", values)
    setTimeout(() => this.restoreFieldsCascade(values), 100);
  }

  // @ts-ignore
  async restoreFieldsCascade(values) {
    // @ts-ignore
    const sidebar = window.courseMaterialsSidebar;
    const fields = {
      division: document.getElementById('division'),
      department: document.getElementById('department'),
      course: document.getElementById('course'),
      section: document.getElementById('section'),
    };
    

    const show_division = window?.show_division || false;

    // Step 1: Division (if needed)
    if (values.division && show_division && fields.division) {
      await sidebar.populateDivision();
      setTimeout(async () => {
        if (fields.division){
          // @ts-ignore
          fields.division.value = values.division;
          // @ts-ignore
          const options = fields.division.options; 
          
          for (let i = 0; i < options.length; i++) {
              if (options[i].text === values.division) {
                  options[i].selected = true; 
                  break; 
              }
          }
        } 
        await this.continueWithDepartment(sidebar, fields, values);
      }, 50);
    } else {
      
      await this.continueWithDepartment(sidebar, fields, values);
    }
  }

  // @ts-ignore
  async continueWithDepartment(sidebar, fields, values) {
    // Step 2: Department
    await sidebar.populateDepartments();
    setTimeout(async () => {
      if (values.department && fields.department) {
        for (let i = 0; i < fields.department.options.length; i++) {
          fields.department.options[i].selected = false;
        }
        const options = fields.department.options;
        for (let i = 0; i < options.length; i++) {
          if (options[i].text === values.department) {
              options[i].selected = true; 
              break; 
          }
        }
      }
      await this.continueWithCourse(sidebar, fields, values);
    }, 50);
  }

  // @ts-ignore
  async continueWithCourse(sidebar, fields, values) {
    // Step 3: Course
    if (values.course && fields.course) {
      await sidebar.populateCourses();
      setTimeout(async () => {
        
        for (let i = 0; i < fields.course.options.length; i++) {
          fields.course.options[i].selected = false;
        }
        const options = fields.course.options;
        for (let i = 0; i < options.length; i++) {
          if (options[i].text === values.course) {
              options[i].selected = true; 
              break; 
          }
        }
        await this.continueWithSection(sidebar, fields, values);
      }, 50);
    } else {
      await this.finishRestore(sidebar);
    }
  }

  // @ts-ignore
  async continueWithSection(sidebar, fields, values) {
    // Step 4: Section
    if (values.section && fields.section) {
      await sidebar.populateSections();
      setTimeout(() => {
        for (let i = 0; i < fields.section.options.length; i++) {
          fields.section.options[i].selected = false;
        }
        const options = fields.section.options;
        for (let i = 0; i < options.length; i++) {
          if (options[i].text === values.section) {
              options[i].selected = true; 
              break; 
          }
        }
        this.finishRestore(sidebar);
      }, 50);
    } else {
      this.finishRestore(sidebar);
    }
  }

  // @ts-ignore
  async finishRestore(sidebar) {
    // Update button state after all fields are set
    //sidebar.updateAddCourseButtonState();
  }

  triggerDepartmentCascadeForRestore() {
    const divisionField = document.getElementById('division_field');
    const show_division = window?.show_division || false;

    if (divisionField) {
      divisionField.hidden = !show_division;
      divisionField.style.display = show_division ? 'block' : 'none';
    }
  }

  attemptURLRestoration() {
    // @ts-ignore
    if (!window.courseMaterialsSidebar) {
      setTimeout(() => this.attemptURLRestoration(), 100);
      return;
    }

    if (!this.urlParamsToRestore) {
      this.showEmptyStateAndHideLoading();
      return;
    }

    const { termsIds, divisions, departments, courses, sections, studentId } = this.urlParamsToRestore;
    const hasCourseParams = [
      termsIds,
      divisions,
      departments,
      courses,
      sections,
    ].some(arr => arr.length > 0);

    if (studentId) {
      this.restoreStudentIdFromURL(studentId, hasCourseParams);
      if (hasCourseParams) {
        this.restoreFormStateFromURL(
          termsIds,
          divisions,
          departments,
          courses,
          sections
        );
      }
      return;
    }

    if (hasCourseParams) {
      this.restoreFormStateFromURL(
        termsIds,
        divisions,
        departments,
        courses,
        sections
      );
    } else {
      this.showEmptyStateAndHideLoading();
    }
  }

  // @ts-ignore
  restoreStudentIdFromURL(studentId, hasCourseParams = false) {
    // @ts-ignore
    if (window.courseMaterialsSidebar) {
      // @ts-ignore
      window.courseMaterialsSidebar.openSidePanel();
    }

    // Open mobile drawer if on mobile - with retry mechanism
    this.openMobileDrawerWithRetry();

    this.expandSkipSection();

    const studentIdField = document.getElementById('student-id');
    if (studentIdField) {
      // @ts-ignore
      studentIdField.value = studentId;
    }

    const campusSelect = document.getElementById('campus');
    // @ts-ignore
    if (campusSelect && window.courseMaterialsSidebar) {
      // @ts-ignore
      window.courseMaterialsSidebar.populateCampus();
      // @ts-ignore
      campusSelect.disabled = false;
    }

    // Hide course selection fields when using Student ID
    this.hideCourseSelectionFields();

    if (!hasCourseParams) {
      this.showEmptyStateAndHideLoading();
    }
  }

  hideCourseSelectionFields() {
    const courseNameSection = document.querySelector('.course-name-section');
    // @ts-ignore
    const courseDetailsTitle = document.querySelector(
      '.course-name-section h3, .course-name-section .section-title'
    );

    if (courseNameSection) {
      // @ts-ignore
      courseNameSection.style.display = 'none';
    }

    // Also hide the "What's the course name?" title if it exists separately
    const courseTitles = document.querySelectorAll('h3, .section-title');
    courseTitles.forEach(title => {
      if (
        title.textContent &&
        title.textContent.includes("What's the course name")
      ) {
        // @ts-ignore
        title.style.display = 'none';
      }
    });
  }

  showCourseSelectionFields() {
    const courseNameSection = document.querySelector('.course-name-section');

    if (courseNameSection) {
      // @ts-ignore
      courseNameSection.style.display = '';
    }

    // Show the "What's the course name?" title
    const courseTitles = document.querySelectorAll('h3, .section-title');
    courseTitles.forEach(title => {
      if (
        title.textContent &&
        title.textContent.includes("What's the course name")
      ) {
        // @ts-ignore
        title.style.display = '';
      }
    });
  }

  openMobileDrawerWithRetry(retryCount = 0, maxRetries = 10) {
    if (window.innerWidth >= 968) return; // Not mobile

    // @ts-ignore
    if (window.courseMaterialsMobileDrawer) {
      // @ts-ignore
      window.courseMaterialsMobileDrawer.open();
      return;
    }

    // Retry if mobile drawer not ready yet
    if (retryCount < maxRetries) {
      setTimeout(() => {
        this.openMobileDrawerWithRetry(retryCount + 1, maxRetries);
      }, 200);
    }
  }

  expandSkipSection() {
    const skipOptions = document.querySelector('.skip-options');
    const chevronIcon = document.querySelector('.chevron-down-icon');

    if (skipOptions && chevronIcon) {
      // @ts-ignore
      skipOptions.style.display = 'block';
      // @ts-ignore
      chevronIcon.style.transform = 'rotate(0deg)';
    }
  }

  showEmptyStateAndHideLoading() {
    // @ts-ignore
    this.callIfExists(window.hideLoadingState);
    // @ts-ignore
    this.callIfExists(window.showEmptyState);
  }

  /**
   * Show term closed error message
   * @param {{ campus: string; term: string; campusEntity: any; termEntity: any; }} termClosedInfo
   */
  showTermClosedError(termClosedInfo) {
    // Hide loading state
    // @ts-ignore
    this.callIfExists(window.hideLoadingState);
    
    // Hide initial placeholder
    const initialPlaceholder = document.getElementById('initial-placeholder');
    if (initialPlaceholder) {
      initialPlaceholder.style.display = 'none';
    }
    
    // Hide filtered products
    const filteredProducts = document.getElementById('filtered-products');
    if (filteredProducts) {
      filteredProducts.innerHTML = '';
    }
    
    // Hide subtitle and SHOP NOW button in header (desktop)
    const desktopSubtitle = document.querySelector('.header-card-discover .course-materials-subtitle');
    // @ts-ignore
    if (desktopSubtitle) desktopSubtitle.style.display = 'none';
    
    const desktopShopNow = document.querySelector('.header-card-discover .form-actions-inline-discover');
    // @ts-ignore
    if (desktopShopNow) desktopShopNow.style.display = 'none';
    
    // Hide subtitle and SHOP NOW button in header (mobile)
    const mobileSubtitle = document.querySelector('.mobile-course-trigger .mobile-main-subtitle');
    // @ts-ignore
    if (mobileSubtitle) mobileSubtitle.style.display = 'none';
    
    const mobileShopNow = document.querySelector('.mobile-course-trigger .form-actions-inline-discover');
    // @ts-ignore
    if (mobileShopNow) mobileShopNow.style.display = 'none';
    
    // Show campus-term bar when campus and term names are present (enough to render the component)
    const campusTermBar = document.getElementById('campus-term-info');
    const campusTermDisplay = document.getElementById('selected-campus-display');
    if (campusTermBar && campusTermDisplay && termClosedInfo.campus && termClosedInfo.term) {
      campusTermDisplay.textContent = `${termClosedInfo.campus} | ${termClosedInfo.term}`;
      campusTermBar.style.display = 'flex';
    }
    
    // Show term closed error message
    const noProductsFound = document.getElementById('no-products-found');
    if (noProductsFound) {
      const courseCodeElement = document.getElementById('term-closed-course-code');
      const termClosedMessage = document.getElementById('term-closed-message');
      
      // Update the course code if available (e.g., "COM 100")
      // @ts-ignore
      if (courseCodeElement && termClosedInfo.department && termClosedInfo.course) {
        // @ts-ignore
        courseCodeElement.textContent = `${termClosedInfo.department} ${termClosedInfo.course}`;
      }
      
      if (termClosedMessage) {
        termClosedMessage.style.display = 'block';
      }
      
      noProductsFound.style.display = 'block';
    }
  }

  /**
   * Show subtitle and SHOP NOW button when term is open
   */
  showTermOpenElements() {
    // Show subtitle and SHOP NOW button in header (desktop)
    const desktopSubtitle = document.querySelector('.header-card-discover .course-materials-subtitle');
    // @ts-ignore
    if (desktopSubtitle) desktopSubtitle.style.display = 'block';
    
    const desktopShopNow = document.querySelector('.header-card-discover .form-actions-inline-discover');
    // @ts-ignore
    if (desktopShopNow) desktopShopNow.style.display = 'flex';
    
    // Show subtitle and SHOP NOW button in header (mobile)
    const mobileSubtitle = document.querySelector('.mobile-course-trigger .mobile-main-subtitle');
    // @ts-ignore
    if (mobileSubtitle) mobileSubtitle.style.display = 'block';
    
    const mobileShopNow = document.querySelector('.mobile-course-trigger .form-actions-inline-discover');
    // @ts-ignore
    if (mobileShopNow) mobileShopNow.style.display = 'flex';
  }

  // @ts-ignore
  callIfExists(fn) {
    if (typeof fn === 'function') {
      fn();
    }
  }

  initialize() {
    this.parseURLParameters();
    setTimeout(() => this.attemptURLRestoration(), 300);
  }

  // @ts-ignore
  updateSelectedFilters(newSelectedFilters) {
    this.selectedFilters = newSelectedFilters;
  }

  getCurrentURLParams() {
    return this.parseURLParameters();
  }

  // @ts-ignore
  setCallbacks(callbacks) {
    if (callbacks.addLabel) this.addLabelCallback = callbacks.addLabel;
    if (callbacks.refreshProducts)
      this.refreshProductsCallback = callbacks.refreshProducts;
  }

  // @ts-ignore
  updateStudentIdInURL(studentId) {
    const params = new URLSearchParams(window.location.search);
    this.setOrDeleteParam(
      params,
      this.URL_PARAMS.STUDENT_ID,
      studentId?.trim()
    );

    const newUrl = params.toString()
      ? `${window.location.pathname}?${params}`
      : window.location.pathname;

    window.history.replaceState({}, '', newUrl);
  }

  clearURLState() {
    this.clearURL();
    this.clearExistingFilters();
    this.urlParamsToRestore = null;
  }
}

// @ts-ignore
window.URLStateManager = URLStateManager;

// @ts-ignore
if (!window.CourseMatSystem) {
  // @ts-ignore
  window.CourseMatSystem = {};
}
// @ts-ignore
window.CourseMatSystem.URLStateManager = URLStateManager;
